import React, {useState, useEffect, useCallback} from 'react';
// import SortableTree from 'react-sortable-tree';
import { SortableTreeWithoutDndContext as SortableTree } from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app
import './IntentTree.css';
import DragAndDrop from './DragAndDrop';

function App(props) {

  var treeVIn = props.tree;

  const formTree = useCallback((tree)=>{

    function formT(treeV){
      var title = treeV.v[0].v;
      var subtitle = treeV.v[1].v;
      var children = treeV.v[4].v.map((aChild, index)=>{
        return formT(aChild);
      });

      return {title, subtitle, children, expanded:true};
    }

    return formT(tree);
  }, []);


  function countTree(treeV){
    var total = 1;
    treeV.children.map((aChild, index)=>{
      var p = countTree(aChild);
      total += p;
      return null;
    })        
    return total;
  }

  var treeDataIn = [formTree(treeVIn)];
  const [treeData, setTreeData] = useState(treeDataIn);

  useEffect(() => {
    var newTree = [formTree(treeVIn)];
    setTreeData(newTree);
    // setArrayOfHeights(0);
  }, [treeVIn, formTree]);


  var numberOfRows = countTree(treeData[0]);

  var inside = <DragAndDrop><SortableTree
              treeData={treeData}
              onChange={treeData => setTreeData(treeData)}
              canDrag={false}
            /></DragAndDrop>
//  
    return <div style={{ height: 10 + numberOfRows * 62 , textAlign:"left"}} >
        {inside}
          </div>

  
    //
}


export default App;

